import type { AutomateTask, CommonAction, ResponseData } from "@iflyrpa/share";
import shareVersion from "@iflyrpa/share/package.json";
import actionVersion from "../package.json";
import { type BaijiahaoLoginParams, baijiahaoLogin } from "./actions/baijiahaoLogin";
import { type BaijiahaoPublishParams, baijiahaoPublish } from "./actions/baijiahaoPublish";
import {
    BjhFansExport,
    type GetWxFansSearchParams,
    TTFansExport,
    WxFansExport,
    XhsFansExport,
} from "./actions/common/FansTool";
import {
    BjhSessionCheck,
    DySessionCheck,
    ShipinhaoSessionCheck,
    TTSessionCheck,
    type WxBjhSessionParams,
    WxSessionCheck,
    XhsSessionCheck,
} from "./actions/common/sessionCheck";
import { type CreateShipinhaoCommentParams, createShipinhaoComment } from "./actions/createShipinhaoComment";
import {
    type DouyinCheckVerifyQrCodeParams,
    DouyinCheckVerifyQrCodeParamsSchema,
    douyinCheckVerifyQrCode,
} from "./actions/douyinCheckVerifyQrCode";
import { type DouyinCreateCommentReplyParams, douyinCreateCommentReply } from "./actions/douyinCreateCommentReply";
import { type DouyinGetCollectionParams, douyinGetCollection } from "./actions/douyinGetCollection";
import { type DouyinGetCommentListParams, douyinGetCommentList } from "./actions/douyinGetCommentList";
import { type DouyinGetCommentReplyListParams, douyinGetCommentReplyList } from "./actions/douyinGetCommentReplyList";
import { type DouyinGetHotParams, douyinGetHot } from "./actions/douyinGetHot";
import { type DouyinGetLocationParams, douyinGetLocation } from "./actions/douyinGetLocation";
import { type DouyinGetMusicParams, douyinGetMusic } from "./actions/douyinGetMusic";
import { type DouyinGetMusicByCategoryParams, douyinGetMusicByCategory } from "./actions/douyinGetMusicByCategory";
import { type DouyinGetMusicCategoryParams, douyinGetMusicCategory } from "./actions/douyinGetMusicCategory";
import { type DouyinGetTopicsParams, douyinGetTopics } from "./actions/douyinGetTopics";
import {
    type DouyinGetVerifyQrCodeParams,
    DouyinGetVerifyQrCodeParamsSchema,
    douyinGetVerifyQrCode,
} from "./actions/douyinGetVerifyQrCode";
import { type DouyinGetWorkListParams, douyinGetWorkList } from "./actions/douyinGetWorkList";
import { DouyinLoginParams, douyinLogin } from "./actions/douyinLogin";
import { type DouyinPublishParams, douyinPublish } from "./actions/douyinPublish";
import { type GetBaijiahaoActivityParams, getBaijiahaoActivity } from "./actions/getBaijiahaoActivity";
import { type GetBaijiahaoConfigParams, getBaijiahaoConfig } from "./actions/getBaijiaohaoConfig";
import { type GetShipinhaoBgmParams, getShipinhaoBgm } from "./actions/getShipinhaoBgm";
import { type GetShipinhaoBgmCategoryParams, getShipinhaoBgmCategory } from "./actions/getShipinhaoBgmCategory";
import { type GetShipinhaoCollectionParams, getShipinhaoCollection } from "./actions/getShipinhaoCollection";
import { type GetShipinhaoCommentListParams, getShipinhaoCommentList } from "./actions/getShipinhaoCommentList";
import { type GetShipinhaoConfigParams, getShipinhaoConfig } from "./actions/getShipinhaoConfig";
import { type GetShipinhaoPostListParams, getShipinhaoPostList } from "./actions/getShipinhaoPostList";
import { type GetToutiaoCollectionParams, getToutiaoCollection } from "./actions/getToutiaoCollection";
import { type GetToutiaoConfigParams, getToutiaoConfig } from "./actions/getToutiaoConfig";
import { type GetWeixinCollectionParams, getWeixinCollection } from "./actions/getWeixinCollection";
import { type GetWeixinConfigParams, getWeixinConfig } from "./actions/getWeixinConfig";
import { getXhsCollection } from "./actions/getXhsCollection";
import { getXhsGroup } from "./actions/getXhsGroup";
import { getXhsHotTopic } from "./actions/getXhsHotTopic";
import { getXhsUnreadCount } from "./actions/getXhsWebUnreadCount";
import { SearchAccountInfo, type SearchAccountInfoParams } from "./actions/searchAccountInfo";
import { type SearchBjhTopicListParams, searchBjhTopicList } from "./actions/searchBjhTopicList";
import { searchBjhUserArticle, type searchBjhUserArticleParams } from "./actions/searchBjhUserArticle";
import { FetchArticles, type FetchArticlesParams } from "./actions/searchPublishInfo";
import { type SearchToutiaoLocationParams, searchToutiaoLocation } from "./actions/searchToutiaoLocation";
import { type SearchToutiaoTopicListParams, searchToutiaoTopicList } from "./actions/searchToutiaoTopicList";
import { type SearchToutiaoUserIDParams, searchToutiaoUserInfo } from "./actions/searchToutiaoUserID";
import { searchWeixinAccountCard, type searchWeixinAccountCardParams } from "./actions/searchWeixinAccountCard";
import { searchWeixinUserArticle, type searchWeixinUserArticleParams } from "./actions/searchWeixinUserArticle";
import { type searchXhsConnectionsParams, searchXhsWebConnections } from "./actions/searchXhsWebConnections";
import { type searchXhsLikesParams, searchXhsWebLikes } from "./actions/searchXhsWebLike";
import { type searchXhsMentionsParams, searchXhsWebMentions } from "./actions/searchXhsWebMentions";
import { searchXiaohongshuLocation, type searchXiaohongshuLocationParams } from "./actions/searchXiaohongshuLocation";
import {
    type SearchXiaohongshuTopicListParams,
    searchXiaohongshuTopicList,
} from "./actions/searchXiaohongshuTopicList";
import {
    searchXiaohongshuUserArticle,
    type searchXiaohongshuUserArticleParams,
} from "./actions/searchXiaohongshuUserArticle";
import { ShipinhaoCheckLinkValidateParams, shipinhaoCheckLinkValidate } from "./actions/shipinhaoCheckLinkValidate";
import { ShipinhaoGetLocationParams, shipinhaoGetLocation } from "./actions/shipinhaoGetLocation";
import { ShipinhaoGetMsgParams, shipinhaoGetMsg } from "./actions/shipinhaoGetMsg";
import { ShipinhaoGetMsgImageParams, shipinhaoGetMsgImage } from "./actions/shipinhaoGetMsgImage";
import { ShipinhaoLoginParams, shipinhaoLogin } from "./actions/shipinhaoLogin";
import { type ShipinhaoPublishParams, shipinhaoPublish } from "./actions/shipinhaoPublish";
import { ShipinhaoSendMsgParams, shipinhaoSendMsg } from "./actions/shipinhaoSendMsg";
import { type ToutiaoLoginParams, toutiaoLogin } from "./actions/toutiaoLogin";
import { type ToutiaoPublishParams, toutiaoPublish } from "./actions/toutiaoPublish";
import { type WeitoutiaoPublishParams, weitoutiaoPublish } from "./actions/weitoutiaoPublish";
import { type WeixinLoginParams, weixinLogin } from "./actions/weixinLogin";
import { type WeixinmpPublishParams, weixinmpPublish } from "./actions/weixinmpPublish";
import { type WeixinPublishParams, weixinPublish } from "./actions/weixinPublish";
import { type XiaohongshuLoginParams, xiaohongshuLogin } from "./actions/xiaohongshuLogin";
import { type XiaohongshuPublishParams, xiaohongshuPublish } from "./actions/xiaohongshuPublish";
import {
    xiaohongshuWebCommentAction,
    type xiaohongshuWebCommentActionParams,
} from "./actions/xiaohongshuWebCommentAction";
import {
    type searchXhsWebIntimacyListParams,
    xiaohongshuWebIntimacySearch,
} from "./actions/xiaohongshuWebIntimacySearch";
import { xiaohongshuWebMsgRead, type xiaohongshuWebMsgReadParams } from "./actions/xiaohongshuWebMsgRead";
import { xiaohongshuWebMsgReply, type xiaohongshuWebMsgReplyParams } from "./actions/xiaohongshuWebMsgReply";
import { xiaohongshuWebNoteFeed, type xiaohongshuWebNoteFeedParams } from "./actions/xiaohongshuWebNoteFeed";
import {
    xiaohongshuWebRelationAction,
    type xiaohongshuWebRelationParams,
} from "./actions/xiaohongshuWebRelationAction";
import { type XhsWebSearchParams, xiaohongshuWebSearch } from "./actions/xiaohongshuWebSearch";
import type { ActiomCommonParams } from "./types";
import { stringifyError } from "./utils";
import { Http } from "./utils/http";
export const BetaFlag = "HuiwenCanary"; // 用于标记是否为测试版本

export class Action {
    constructor(private task: AutomateTask) {
        this.task.logger.info(`当前包版本：Share=>${shareVersion.version} Action=>${actionVersion.version}`);
    }

    // 绑定 task, 并处理异常
    private async bindTask<T extends ActiomCommonParams, R>(func: CommonAction<T, R>, params: T) {
        let responseData: ResponseData<R>;

        // 检查是否为测试版本
        this.task.isBeta = this.task?.isFeatOn ? this.task?.isFeatOn(BetaFlag) : false;

        // 记录时间消耗
        this.task._timerRecord.ActionStart = Date.now();

        if (this.task?.setArticleId) {
            // 给所有的日志添加 articleId 标签
            this.task.setArticleId(params.articleId ?? "");
        }

        if (this.task?.setSaveType ?? false) {
            // 给所有的日志添加 saveType 标签
            this.task.setSaveType(params.saveType ?? "");
        }

        if (this.task?.isInitializedGB !== undefined) {
            this.task.setGbInitType(this.task.isInitializedGB);
        }

        if (typeof params === "object") {
            // 默认设置 cookies
            params.cookies = params?.cookies ?? [];
        }

        try {
            responseData = await func(this.task, params);
        } catch (error) {
            responseData = Http.handleApiError(error);
        } finally {
            this.task._timerRecord.ActionEnd = Date.now();
        }

        if (this.task.setTimeConsuming) {
            // 收集各时间节点
            this.task.setTimeConsuming(this.task._timerRecord);
        }

        if (responseData.code === 414) {
            // 表示是由于脚本输入信息错误导致的失败，不是脚本问题
            this.task.logger.info(`${func.name} action params error`, responseData);
        } else if (responseData.code !== 0) {
            this.task.logger.error(
                responseData.message || `${func.name} 执行失败`,
                stringifyError(responseData.data),
                responseData.extra,
            );
            this.task.logger.info(`${func.name} action failed`);
        } else {
            this.task.logger.info(`${func.name} action success`);
        }

        if (this.task.debug && this.task._timerRecord.PrePublish) {
            console.log(
                "预处理图片耗时：",
                (this.task._timerRecord.PrePublish - this.task._timerRecord.ActionStart) / 1000,
                "s",
            );
            console.log(
                "发文接口耗时：",
                (this.task._timerRecord.ActionEnd - this.task._timerRecord.PrePublish) / 1000,
                "s",
            );
        }
        this.task.debug &&
            console.log(
                "Action整体耗时：",
                (this.task._timerRecord.ActionEnd - this.task._timerRecord.ActionStart) / 1000,
                "s",
            );

        return responseData;
    }

    // 小红书操作web笔记搜索
    xiaohongshuWebSearch(params: XhsWebSearchParams) {
        return this.bindTask(xiaohongshuWebSearch, params);
    }

    // 小红书操作指定web评论点赞/取消点赞
    xiaohongshuWebCommentAction(params: xiaohongshuWebCommentActionParams) {
        return this.bindTask(xiaohongshuWebCommentAction, params);
    }

    // 小红书获取指定文章详情
    xiaohongshuWebNoteFeed(params: xiaohongshuWebNoteFeedParams) {
        return this.bindTask(xiaohongshuWebNoteFeed, params);
    }

    // 小红书操作指定id用户关系（关注/取关）
    xiaohongshuWebRelationAction(params: xiaohongshuWebRelationParams) {
        return this.bindTask(xiaohongshuWebRelationAction, params);
    }

    // 小红书回复指定笔记评论
    xiaohongshuWebMsgRead(params: xiaohongshuWebMsgReadParams) {
        return this.bindTask(xiaohongshuWebMsgRead, params);
    }

    // 小红书获取@提及列表
    xiaohongshuWebIntimacySearch(params: searchXhsWebIntimacyListParams) {
        return this.bindTask(xiaohongshuWebIntimacySearch, params);
    }

    // 小红书回复指定笔记评论
    xiaohongshuWebMsgReply(params: xiaohongshuWebMsgReplyParams) {
        return this.bindTask(xiaohongshuWebMsgReply, params);
    }

    // 小红书获取新增关注列表
    searchXhsWebConnections(params: searchXhsConnectionsParams) {
        return this.bindTask(searchXhsWebConnections, params);
    }

    // 小红书获取赞和收藏列表
    searchXhsWebLikes(params: searchXhsLikesParams) {
        return this.bindTask(searchXhsWebLikes, params);
    }

    // 小红书获取评论与@提及列表
    searchXhsWebMentions(params: searchXhsMentionsParams) {
        return this.bindTask(searchXhsWebMentions, params);
    }

    // 小红书获取未读消息数
    getXhsUnreadCount(params: ActiomCommonParams) {
        return this.bindTask(getXhsUnreadCount, params);
    }

    // 百家号搜索用户文章
    searchBjhUserArticle(params: searchBjhUserArticleParams) {
        return this.bindTask(searchBjhUserArticle, params);
    }

    // 小红书搜索用户文章
    searchXiaohongshuUserArticle(params: searchXiaohongshuUserArticleParams) {
        return this.bindTask(searchXiaohongshuUserArticle, params);
    }

    // 微信搜索用户文章
    searchWeixinUserArticle(params: searchWeixinUserArticleParams) {
        return this.bindTask(searchWeixinUserArticle, params);
    }

    // 微信号搜索账号卡片
    searchWeixinAccountCard(params: searchWeixinAccountCardParams) {
        return this.bindTask(searchWeixinAccountCard, params);
    }

    // 微信登陆操作 仅用于Cli框架
    WxLogin(params: WeixinLoginParams) {
        return this.bindTask(weixinLogin, params);
    }

    // 百家号登陆操作 仅用于Cli框架
    BaijiahaoLogin(params: BaijiahaoLoginParams) {
        return this.bindTask(baijiahaoLogin, params);
    }

    // 头条号登陆操作 仅用于Cli框架
    ToutiaoLogin(params: ToutiaoLoginParams) {
        return this.bindTask(toutiaoLogin, params);
    }

    // 抖音创作者中心登陆
    DouyinLogin(params: DouyinLoginParams) {
        return this.bindTask(douyinLogin, params);
    }

    // 视频号登陆
    ShipinhaoLogin(params: ShipinhaoLoginParams) {
        return this.bindTask(shipinhaoLogin, params);
    }

    // 小红书登陆操作 仅用于Cli框架
    XhsLogin(params: XiaohongshuLoginParams) {
        return this.bindTask(xiaohongshuLogin, params);
    }

    // 获取指定平台的文章数据
    FetchArticles(params: FetchArticlesParams) {
        return this.bindTask(FetchArticles, params);
    }

    // 获取指定平台的分析数据
    SearchAccountInfo(params: SearchAccountInfoParams) {
        return this.bindTask(SearchAccountInfo, params);
    }

    // 头条Session有效性检测
    TTSessionCheck(params: ActiomCommonParams) {
        return this.bindTask(TTSessionCheck, params);
    }

    // 微信Session有效性检测
    WxSessionCheck(params: WxBjhSessionParams) {
        return this.bindTask(WxSessionCheck, params);
    }

    // 小红书Session有效性检测
    XhsSessionCheck(params: ActiomCommonParams) {
        return this.bindTask(XhsSessionCheck, params);
    }

    // 百家号Session有效性检测
    BjhSessionCheck(params: WxBjhSessionParams) {
        return this.bindTask(BjhSessionCheck, params);
    }

    // 抖音Session有效性检测
    DySessionCheck(params: ActiomCommonParams) {
        return this.bindTask(DySessionCheck, params);
    }

    // 视频号Session有效性检测
    ShipinhaoSessionCheck(params: ActiomCommonParams) {
        return this.bindTask(ShipinhaoSessionCheck, params);
    }

    // 搜索头条话题列表
    searchToutiaoTopicList(params: SearchToutiaoTopicListParams) {
        return this.bindTask(searchToutiaoTopicList, params);
    }

    // 搜索头条粉丝
    TTFansExport(params: ActiomCommonParams) {
        return this.bindTask(TTFansExport, params);
    }

    // 搜索小红书粉丝
    XhsFansExport(params: ActiomCommonParams) {
        return this.bindTask(XhsFansExport, params);
    }

    // 搜索微信粉丝
    WxFansExport(params: GetWxFansSearchParams) {
        return this.bindTask(WxFansExport, params);
    }

    // 搜索百家号粉丝
    BjhFansExport(params: ActiomCommonParams) {
        return this.bindTask(BjhFansExport, params);
    }

    SearchBjhTopicList(params: SearchBjhTopicListParams) {
        return this.bindTask(searchBjhTopicList, params);
    }

    // 搜索头条用户ID
    searchToutiaoUserID(params: SearchToutiaoUserIDParams) {
        return this.bindTask(searchToutiaoUserInfo, params);
    }

    // 搜索头条Location
    searchToutiaoLocation(params: SearchToutiaoLocationParams) {
        return this.bindTask(searchToutiaoLocation, params);
    }

    // 获取头条配置
    getToutiaoConfig(params: GetToutiaoConfigParams) {
        return this.bindTask(getToutiaoConfig, params);
    }

    // 获取头条合集
    getToutiaoCollection(params: GetToutiaoCollectionParams) {
        return this.bindTask(getToutiaoCollection, params);
    }

    // 获取微信配额
    getWeixinConfig(params: GetWeixinConfigParams) {
        return this.bindTask(getWeixinConfig, params);
    }

    // 获取微信合集
    getWeixinCollection(params: GetWeixinCollectionParams) {
        return this.bindTask(getWeixinCollection, params);
    }

    // 获取视频号配置
    getShipinhaoConfig(params: GetShipinhaoConfigParams) {
        return this.bindTask(getShipinhaoConfig, params);
    }

    // 获取视频号合集
    getShipinhaoCollection(params: GetShipinhaoCollectionParams) {
        return this.bindTask(getShipinhaoCollection, params);
    }

    // 获取视频号背景音乐
    getShipinhaoBgm(params: GetShipinhaoBgmParams) {
        return this.bindTask(getShipinhaoBgm, params);
    }

    // 获取视频号背景音乐类型
    getShipinhaoBgmCategory(params: GetShipinhaoBgmCategoryParams) {
        return this.bindTask(getShipinhaoBgmCategory, params);
    }

    // 获取视频号已发布文章列表
    getShipinhaoPostList(params: GetShipinhaoPostListParams) {
        return this.bindTask(getShipinhaoPostList, params);
    }

    // 获取视频号评论列表
    getShipinhaoCommentList(params: GetShipinhaoCommentListParams) {
        return this.bindTask(getShipinhaoCommentList, params);
    }

    // 创建视频号评论
    createShipinhaoComment(params: CreateShipinhaoCommentParams) {
        return this.bindTask(createShipinhaoComment, params);
    }

    getXhsCollection(params: ActiomCommonParams) {
        return this.bindTask(getXhsCollection, params);
    }

    getXhsGroup(params: ActiomCommonParams) {
        return this.bindTask(getXhsGroup, params);
    }

    getXhsHotTopic(params: ActiomCommonParams) {
        return this.bindTask(getXhsHotTopic, params);
    }

    // 获取百家号配置
    getBaijiahaoConfig(params: GetBaijiahaoConfigParams) {
        return this.bindTask(getBaijiahaoConfig, params);
    }

    // 百家号发布
    baijiahaoPublish(params: BaijiahaoPublishParams) {
        return this.bindTask(baijiahaoPublish, params);
    }

    // 查询百家号活动投稿
    getBaijiahaoActivity(params: GetBaijiahaoActivityParams) {
        return this.bindTask(getBaijiahaoActivity, params);
    }

    // 小红书发布
    xiaohongshuPublish(params: XiaohongshuPublishParams) {
        return this.bindTask(xiaohongshuPublish, params);
    }

    // 搜索小红书话题
    searchXiaohongshuTopicList(params: SearchXiaohongshuTopicListParams) {
        return this.bindTask(searchXiaohongshuTopicList, params);
    }
    // 搜索小红书地址
    searchXiaohongshuLocation(params: searchXiaohongshuLocationParams) {
        return this.bindTask(searchXiaohongshuLocation, params);
    }

    // 小绿书发布
    weixinmpPublish(params: WeixinmpPublishParams) {
        return this.bindTask(weixinmpPublish, params);
    }

    // 微头条发布
    weitoutiaoPublish(params: WeitoutiaoPublishParams) {
        return this.bindTask(weitoutiaoPublish, params);
    }

    // 头条发布
    toutiaoPublish(params: ToutiaoPublishParams) {
        return this.bindTask(toutiaoPublish, params);
    }

    // 微信发布
    weixinPublish(params: WeixinPublishParams) {
        return this.bindTask(weixinPublish, params);
    }
    //抖音发布
    douyinPublish(params: DouyinPublishParams) {
        return this.bindTask(douyinPublish, params);
    }

    // 抖音校验二维码扫码状态
    douyinCheckVerifyQrCode(params: DouyinCheckVerifyQrCodeParams) {
        return this.bindTask(douyinCheckVerifyQrCode, params);
    }

    // 抖音获取二维码扫码状态
    douyinGetVerifyQrCode(params: DouyinGetVerifyQrCodeParams) {
        return this.bindTask(douyinGetVerifyQrCode, params);
    }

    // 视频号发布
    shipinhaoPublish(params: ShipinhaoPublishParams) {
        return this.bindTask(shipinhaoPublish, params);
    }

    douyinGetTopics(params: DouyinGetTopicsParams) {
        return this.bindTask(douyinGetTopics, params);
    }
    douyinGetMusicCategory(params: DouyinGetMusicCategoryParams) {
        return this.bindTask(douyinGetMusicCategory, params);
    }
    douyinGetMusicByCategory(params: DouyinGetMusicByCategoryParams) {
        return this.bindTask(douyinGetMusicByCategory, params);
    }
    douyinGetMusic(params: DouyinGetMusicParams) {
        return this.bindTask(douyinGetMusic, params);
    }
    douyinGetLocation(params: DouyinGetLocationParams) {
        return this.bindTask(douyinGetLocation, params);
    }
    douyinGetHot(params: DouyinGetHotParams) {
        return this.bindTask(douyinGetHot, params);
    }
    douyinGetCollection(params: DouyinGetCollectionParams) {
        return this.bindTask(douyinGetCollection, params);
    }
    douyinGetCommentList(params: DouyinGetCommentListParams) {
        return this.bindTask(douyinGetCommentList, params);
    }
    douyinGetCommentReplyList(params: DouyinGetCommentReplyListParams) {
        return this.bindTask(douyinGetCommentReplyList, params);
    }
    douyinCreateCommentReply(params: DouyinCreateCommentReplyParams) {
        return this.bindTask(douyinCreateCommentReply, params);
    }
    douyinGetWorkList(params: DouyinGetWorkListParams) {
        return this.bindTask(douyinGetWorkList, params);
    }
    douyinLogin(params: DouyinLoginParams) {
        return this.bindTask(douyinLogin, params);
    }
    shipinhaoCheckLinkValidate(params: ShipinhaoCheckLinkValidateParams) {
        return this.bindTask(shipinhaoCheckLinkValidate, params);
    }
    shipinhaoGetLocation(params: ShipinhaoGetLocationParams) {
        return this.bindTask(shipinhaoGetLocation, params);
    }
    shipinhaoGetMsg(params: ShipinhaoGetMsgParams) {
        return this.bindTask(shipinhaoGetMsg, params);
    }
    shipinhaoGetMsgImage(params: ShipinhaoGetMsgImageParams) {
        return this.bindTask(shipinhaoGetMsgImage, params);
    }
    shipinhaoSendMsg(params: ShipinhaoSendMsgParams) {
        return this.bindTask(shipinhaoSendMsg, params);
    }
}

type ActionInstance = InstanceType<typeof Action>;

// 提取方法的参数类型
type MethodParams<T> = {
    // biome-ignore lint/suspicious/noExplicitAny: 有使用 any
    [K in keyof T]: T[K] extends (...args: any[]) => unknown ? Parameters<T[K]>[0] : never;
};

// 应用于 Action 类的实例
export type ActionMethodParams = MethodParams<ActionInstance>;

export { version } from "../package.json";
export { type BaijiahaoPublishParams, BaijiahaoPublishParamsSchema } from "./actions/baijiahaoPublish";
export type { sessionCheckResult } from "./actions/common/sessionCheck";
export {
    SessionCheckResultSchema,
    type WxBjhSessionParams,
    WxBjhSessionParamsSchema,
} from "./actions/common/sessionCheck";
export type {
    CreateCommentResponse,
    CreateShipinhaoCommentParams,
} from "./actions/createShipinhaoComment";
export {
    type DouyinCheckVerifyQrCodeParams,
    DouyinCheckVerifyQrCodeParamsSchema,
    type QrCodeCheckResult,
    type QrCodeStatusConfirmed,
    type QrCodeStatusExpired,
    type QrCodeStatusNew,
} from "./actions/douyinCheckVerifyQrCode";
export {
    type DouyinCreateCommentReplyParams,
    DouyinCreateCommentReplyParamsSchema,
} from "./actions/douyinCreateCommentReply";
export { type DouyinGetCollectionParams, DouyinGetCollectionParamsSchema } from "./actions/douyinGetCollection";
export { type DouyinGetCommentListParams, DouyinGetCommentListParamsSchema } from "./actions/douyinGetCommentList";
export {
    type DouyinGetCommentReplyListParams,
    DouyinGetCommentReplyListParamsSchema,
} from "./actions/douyinGetCommentReplyList";
export { type DouyinGetHotParams, DouyinGetHotParamsSchema } from "./actions/douyinGetHot";
export { type DouyinGetLocationParams, DouyinGetLocationParamsSchema } from "./actions/douyinGetLocation";
export { type DouyinGetMusicParams, DouyinGetMusicParamsSchema } from "./actions/douyinGetMusic";
export {
    type DouyinGetMusicByCategoryParams,
    DouyinGetMusicByCategoryParamsSchema,
} from "./actions/douyinGetMusicByCategory";
export {
    type DouyinGetMusicCategoryParams,
    DouyinGetMusicCategoryParamsSchema,
} from "./actions/douyinGetMusicCategory";
export { type DouyinGetTopicsParams, DouyinGetTopicsParamsSchema } from "./actions/douyinGetTopics";
export {
    type DouyinGetVerifyQrCodeParams,
    DouyinGetVerifyQrCodeParamsSchema,
} from "./actions/douyinGetVerifyQrCode";
export { type DouyinGetWorkListParams, DouyinGetWorkListParamsSchema } from "./actions/douyinGetWorkList";
export type { DouyinLoginParams } from "./actions/douyinLogin";
export { type DouyinPublishParams, DouyinPublishParamsSchema } from "./actions/douyinPublish";
export { ConfigDataSchema } from "./actions/getBaijiaohaoConfig";
export type { BgmDetail, BgmListResponse, GetShipinhaoBgmParams } from "./actions/getShipinhaoBgm";
export type {
    BgmCategoryDetail,
    BgmCategoryListResponse,
    GetShipinhaoBgmCategoryParams,
} from "./actions/getShipinhaoBgmCategory";
export type {
    CollectionDetail as ShipinhaoCollectionDetail,
    CollectionDetailResponse,
    GetShipinhaoCollectionParams,
} from "./actions/getShipinhaoCollection";
export type {
    CommentDetail,
    CommentListResponse,
    GetShipinhaoCommentListParams,
} from "./actions/getShipinhaoCommentList";
export type {
    GetShipinhaoPostListParams,
    PostDetail,
    PostListResponse,
} from "./actions/getShipinhaoPostList";
export { type CollectionDetail, CollectionDetailSchema } from "./actions/getXhsCollection";
export { type UnreadCount, UnreadCountSchema } from "./actions/getXhsWebUnreadCount";
export { type SearchAccountInfoParams, SearchAccountInfoParamsSchema } from "./actions/searchAccountInfo";
export {
    type bjhConfigData,
    bjhConfigDataSchema,
    type douyinConfigData,
    douyinConfigDataSchema,
    type shipinhaoConfigData,
    shipinhaoConfigDataSchema,
    type ttConfigData,
    ttConfigDataSchema,
    type wxConfigData,
    wxConfigDataSchema,
    type xhsConfigData,
    xhsConfigDataSchema,
} from "./actions/searchAccountInfo/types";
export { type FetchArticlesParams, FetchArticlesParamsSchema } from "./actions/searchPublishInfo";
export { type FetchArticlesData, FetchArticlesDataSchema } from "./actions/searchPublishInfo/types";
export {
    type ShipinhaoCheckLinkValidateParams,
    ShipinhaoCheckLinkValidateParamsSchema,
} from "./actions/shipinhaoCheckLinkValidate";
export { type ShipinhaoGetLocationParams, ShipinhaoGetLocationParamsSchema } from "./actions/shipinhaoGetLocation";
export { type ShipinhaoGetMsgParams, ShipinhaoGetMsgParamsSchema } from "./actions/shipinhaoGetMsg";
export type { ShipinhaoLoginParams } from "./actions/shipinhaoLogin";
export { type ShipinhaoPublishParams, ShipinhaoPublishParamsSchema } from "./actions/shipinhaoPublish";
export { type ShipinhaoSendMsgParams, ShipinhaoSendMsgParamsSchema } from "./actions/shipinhaoSendMsg";
export { type ToutiaoPublishParams, ToutiaoPublishParamsSchema } from "./actions/toutiaoPublish";
export { type WeixinPublishParams, WeixinPublishParamsSchema } from "./actions/weixinPublish";
export { type XiaohongshuPublishParams, XiaohongshuPublishParamsSchema } from "./actions/xiaohongshuPublish";
export { type XhsWebSearchParams, XhsWebSearchParamsSchema } from "./actions/xiaohongshuWebSearch";
export { type ActiomCommonParams, ActionCommonParamsSchema } from "./types";
export { getFileState } from "./utils";
export { Http } from "./utils/http";
export { ProxyAgent } from "./utils/proxy";
export { reportLogger } from "./utils/reportLogger";
// 内部测试方法

export { rpaAction_Server_Mock } from "./actions/xiaohongshuPublish/rpa-server-mock";
